$(document).ready(function(){
	
	$('#printInfo').on('click',function(){
		window.print();
	});

	textArr = $("#selectPrice option:selected").data("price");
	$('#reservationText').html(textArr);
	
	$('#selectPrice').on('change', function() {
		textArr = $("#selectPrice option:selected").data("price");
		$('#reservationText').html(textArr);
		$("input[type='hidden'][name='tourPriceKey']").val($(this).val());
	});
	
	$('#selectDate').on('change', function() {
		$('.hotel-row').hide();
		$('.hotel-date-'+$(this).val()).show();
	}).trigger('change');

    $("input[type='hidden'][name='tourPriceKey']").val($('#selectPrice').val());

    // Daily tour pax selection
    $('.roomSelect').val("1");

    var spinADT = $( ".spinnerTravelerADT" ).spinner({
        min: 1,
        max: 2
    });
    var spinCHD = $( ".spinnerTravelerCHD" ).spinner({
        min: 0,
        max: 2
    });
    var spinINF = $( ".spinnerTravelerINF" ).spinner({
        min: 0,
        max: 2
    });

    $(".spinnerTravelerADT, .spinnerTravelerCHD, .spinnerTravelerINF").change(function(){
        var paxADT = spinADT.spinner( "value" );
        var paxCHD = spinCHD.spinner( "value" );
        var paxINF = spinINF.spinner( "value" );
        var totalPax = paxADT + paxCHD + paxINF;
        $(".travelerSelectPax").html(totalPax);
        var locale = $.cookie('siteLocale');
        if(locale == "en"){
            if(totalPax > 1){
                $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.travelers'));
            }else{
                $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler'));
            }
        }else if(locale == "ru" || locale == "uk"){
            var partLast2 = totalPax % 100;
            var partLast1 = totalPax % 10;
            if(partLast1 == 0 || (partLast1 >= 5 && partLast1 <= 9) || (partLast2 >= 11 && partLast2 <= 14)){
                $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru3'));
            }else if(partLast1 == 1){
                $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru1'));
            }else if(partLast1 >= 2 && partLast1 <= 4){
                $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler.ru2'));
            }
        }else{
            $(".travelerFmt").html(FmtMessage.getMessage('js.passanger.type.traveler'));
        }
    });

    $(".spinnerTravelerADT, .spinnerTravelerCHD, .spinnerTravelerINF").on("spinstop",function(){
        $(this).change();
    });$(".btn-detailed").click(function() {
        $('.detailed-search').toggle("fade","fast");
        $(this).toggleClass("btn-close");
        return false;
    });

    // Package tour pax selection
    $( ".roomSelect" ).spinner({});
    $( ".adultCount" ).spinner({});
    $( ".childCount" ).spinner({});
    $( ".childAge" ).spinner({});

    $(document).on("spinstop",".roomSelect, .adultCount, .childCount, .childAge",function(){
        $(this).change();
    });

    $(document).on("click",".selectPerson",function() {
        $(".person-popover").toggle("fade","fast");

        $( ".roomSelect" ).spinner({});
        $( ".adultCount" ).spinner({});
        $( ".childCount" ).spinner({});
        $( ".childAge" ).spinner({});
        return false;
    });

    bindRoomSelector();

	$( ".show-photos" ).click(function() {
		$("#photosModal").modal('show');
	});
	
});

function directIntoReservationPage(tourId){
	$("input[type='hidden'][name='tourId']").val(tourId);
	var $form = $('[name="priceDetailToursForm"]');
	$form.submit();
}

function continueToReservationPage(tourId,tourPriceKey){
	$("input[type='hidden'][name='tourId']").val(tourId);
	$("input[type='hidden'][name='tourPriceKey']").val(tourPriceKey);
	var $form = $('[name="priceDetailToursForm"]');
	$form.submit();
}

function bindRoomSelector(context) {

    if (context == undefined)
        context = document;

    $(".roomSelect", context).on('change', function(event) {

        var roomCount = $(this).val();
        $(".roomSelect").val(roomCount);
        $(".travelerSelectRoom").html(roomCount);
        for ( var i = 1; i < 5; i++) {
            if (i <= roomCount) {
                $(".room" + i).show();
            } else {
                $(".room" + i).hide();
            }
        }
//		$(this).closest("form").find(".travelerSelectRoom").html(roomCount);
        setTotalGuest($(this).closest("form"));

        var locale = $.cookie('siteLocale');
        if(locale == "en" && roomCount > 1){
            $(".travelerRoomFmt").html(FmtMessage.getMessage('js.hotel.search.title.rooms'));
        }else{
            $(".travelerRoomFmt").html(FmtMessage.getMessage('js.hotel.search.title.room'));
        }

    }).change();

    $(".childCount", context).on('change', function (event) {

        var childCount =  parseInt(this.value);
        var index = this.name.split('_')[1];
        $("[name="+this.name+"]").val(childCount);

        for ( var i = 1; i < 4; i++) {
            if (i <= childCount) {
                $(".childAge" + index + i).show();
            } else {
                $(".childAge" + index + i).hide();
            }
        }

        setTotalGuest($(this).closest("form"));

    }).change();

    $(".adultCount", context).on('change', function (event) {
        $("[name="+this.name+"]").val(parseInt(this.value));
        setTotalGuest($(this).closest("form"));
    }).change();

    $(".childAge", context).on('change', function (event) {
        $("[name="+this.name+"]").val(parseInt(this.value));
    }).change();

}

function setTotalGuest(form) {
    var roomCount = parseInt(form.find("#glRoomCount").val());
    var totalAdultCount = 0;
    var totalChildCount = 0;
    for ( var i = 1; i <= roomCount; i++) {
        totalAdultCount = totalAdultCount + parseInt(form.find("[name=adultCount_" + i + "]").val());
        totalChildCount = totalChildCount + parseInt(form.find("[name=childCount_" + i + "]").val());
    }
    var totalGuest = totalAdultCount + totalChildCount;
    $(".travelerSelectGuest").html(totalGuest);
    var locale = $.cookie('siteLocale');
    if(locale == "en" && totalGuest > 1){
        $(".travelerGuestFmt").html(FmtMessage.getMessage('js.hotel.search.title.guests'));
    }else{
        $(".travelerGuestFmt").html(FmtMessage.getMessage('js.hotel.search.title.guest'));
    }
}
